/**
 * 医学工具配置
 * 统一管理所有工具的类型、标题、路径等信息
 */

// 引入新增公式配置
import { NEW_FORMULA_TOOLS, NEW_FORMULA_TOOLS_TREATMENT } from './newFormulasConfig'

// 列表小图标（云端资源）
const SMALL_ICON_TNM = 'https://bosdev.liangyihui.net/medseek_icon_tnm.png'
const SMALL_ICON_GUIDE = 'https://bosdev.liangyihui.net/medseek_icon_guide.png'
const SMALL_ICON_DRUG = 'https://bosdev.liangyihui.net/medseek_icon_drug.png'
const SMALL_ICON_CHEMO = 'https://bosdev.liangyihui.net/medseel_icon_chemo.png'
const SMALL_ICON_FORMULA = 'https://bosdev.liangyihui.net/medseek_icon_formula.png'
const SMALL_ICON_SCALE = 'https://bosdev.liangyihui.net/medseek_icon_scale.png'

// 工具类型枚举
export const TOOL_TYPES = {
  TNM: 1,           // 肿瘤分期
  CLINICAL_GUIDE: 2, // 临床指南
  MEDICATION: 3,    // 用药助手
  CHEMOTHERAPY: 4,  // 化疗手册
  AI_CASE: 5,       // AI病历夹
  TUMOR_RESEARCH: 6, // 肿瘤研究
  BSA: 7,           // 体表面积计算公式（BSA）
  CARBO: 8,         // 卡铂剂量计算公式
  CCR: 9,           // 肌酐清除率计算公式（Ccr）
  BMI: 10,          // 身体质量指数（BMI）
  BED: 11,          // 生物有效剂量（BED）计算公式
  SNSF: 12,         // 低钠血症钠缺失计算公式
  ZPS: 13,          // ECOG体力状态评分(ZPS，5分法)
  KPS: 14,          // 体力状态评分（KPS，百分法）
  PAIN_GRADING: 15, // 肿瘤患者癌痛主诉疼痛分级
  CTCAE: 16,        // 常见不良事件评价标准（CTCAE）5.0  
  STEPP: 17,     // 早期绝经前激素受体阳性乳腺癌综合复发风险评分（STEPP评分）
  GFR: 18,     // 肾小球滤过率（GFR）估算公式（CKD-EPI公式）
  PAINWHO: 19,     // 疼痛分级-WHO疼痛分级标准
  PAINNRS: 20,     // 疼痛分级-数字分级评分法（NRS）
  PAINVAS: 21,     // 视觉模拟评分法 (VAS)
  PAINFPS: 22,     // 面部表情评分量表 (FPS)
  MIRELS: 23,     // 病理性骨折风险评分系统（Mirels 评分系统）
  GCRSS: 24,     // 中国人群胃癌风险评分系统（GC-RSS评分）
  CRS: 25,     // 结直肠癌肝转移预后风险评分（CRS评分）
  NORDLINGER: 26,     // 结直肠癌肝转移预后风险评分（Nordlinger评分）
  NSNRS: 27,     // 营养风险筛查2002（NRS 2002 ）
  NSMUST: 28,     // 营养不良通用筛查工具（MUST）
  PRABRADEN: 29,     // 压疮危险评估量-Braden量表
  PRANORTON: 30,     // 压疮危险评估量-Norton量表
  RECIST: 31,     // 实体瘤的疗效评价标准（RECIST 1.1)
  CTS5: 32,     // 临床治疗5年后风险评分（CTS5）
  CTCAE6: 33,     // 常见不良事件评价标准（CTCAE）6.0
}

// 主要工具配置（顶部大卡片）
export const TOP_TOOLS = [
  {
    toolType: TOOL_TYPES.TNM,
    title: '肿瘤分期',
    img: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/swY0y4jmmGJg0m18.png',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/dIQbo1lwCn9oTuUy.png',
    link: Global_root_path + '#/tools/tnm/list',
    routerPath: '/tools/tnm/list',
    miniPath: '/pages/TNM/TNM',
    description: 'TNM分期工具',
    miniTitle: '分期'
  },
  {
    toolType: TOOL_TYPES.CLINICAL_GUIDE,
    title: '临床指南',
    img: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/u9G0l6uyRhtBFYkY.png',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/9B9tUyLWt8iPSWbR.png',
    link: Global_root_path + '#/tools/cpg/list',
    routerPath: '/tools/cpg/list',
    miniPath: '/pages/DiagnosisGuide/DiagnosisGuide',
    description: '临床诊疗指南',
    miniTitle: '指南'
  }
]

// 功能工具配置（四个小图标）
export const FUNCTION_TOOLS = [
  {
    toolType: TOOL_TYPES.CHEMOTHERAPY,
    title: '化疗手册',
    img: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/smZuWQ0bgFjSLZHu.png',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/smZuWQ0bgFjSLZHu.png',
    link: Global_root_path + '#/tools/cmm/home?cmm_page_source=工具聚合页',
    routerPath: '/tools/cmm/home',
    miniPath: '/pages/tumorHand/tumorHand',
    description: '化疗方案手册',
    miniTitle: '化疗'
  },
  {
    toolType: TOOL_TYPES.MEDICATION,
    title: '用药助手',
    img: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/3sHRZ0qGBj6qqsp3.png',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/3sHRZ0qGBj6qqsp3.png',
    link: Global_root_path + '#/tools/da/main',
    routerPath: '/tools/da/main',
    miniPath: '/pages/tools/da/main',
    description: '用药指导工具',
    miniTitle: '用药'
  },
  {
    toolType: TOOL_TYPES.TUMOR_RESEARCH,
    title: '肿瘤研究',
    img: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hILy47pk2N3wALP4.png',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hILy47pk2N3wALP4.png',
    link: Global_root_path + '#/tools/trj/list',
    routerPath: '/tools/trj/list',
    miniPath: '/pages/SQSMIndex/SQSMIndex',
    description: '肿瘤研究进展',
    miniTitle: '研究'
  }
]

// 公式工具配置（医学公式相关）分为 treatment 和 evaluation 两部分
export const FORMULA_TOOLS_TREATMENT = [
  {
    toolType: TOOL_TYPES.BSA,
    title: '体表面积计算公式（BSA）',
    img: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/Y4eHWNNQuQaYwKUH.png',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/bsa',
    routerPath: '/tools/formula/treatment/bsa',
    miniPath: '/pages/tools/formula/treatment/bsa',
    description: '计算人体体表面积'
  },
  {
    toolType: TOOL_TYPES.CARBO,
    title: '卡铂剂量计算公式',
    img: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/CsKkrpFT6hvCjhq7.png',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/carbo',
    routerPath: '/tools/formula/treatment/carbo',
    miniPath: '/pages/tools/formula/treatment/carbo',
    description: '卡铂药物剂量计算'
  },
  {
    toolType: TOOL_TYPES.CCR,
    title: '肌酐清除率计算公式（Ccr）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/ccr',
    routerPath: '/tools/formula/treatment/ccr',
    miniPath: '/pages/tools/formula/treatment/ccr',
    description: '肌酐清除率计算'
  },
  {
    toolType: TOOL_TYPES.BED,
    title: '生物有效剂量（BED）计算公式',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/bed',
    routerPath: '/tools/formula/treatment/bed',
    miniPath: '/pages/tools/formula/treatment/bed',
    description: '生物有效剂量计算'
  },
  {
    toolType: TOOL_TYPES.SNSF,
    title: '低钠血症钠缺失计算公式',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/snsf',
    routerPath: '/tools/formula/treatment/snsf',
    miniPath: '/pages/tools/formula/treatment/snsf',
    description: '低钠血症治疗计算'
  },
  {
    toolType: TOOL_TYPES.GFR,
    title: '肾小球滤过率（GFR）估算公式（CKD-EPI公式）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/treatment/gfr',
    routerPath: '/tools/formula/treatment/gfr',
    miniPath: '/pages/tools/formula/treatment/gfr',
    description: '肾小球滤过率（GFR）估算公式（CKD-EPI公式）'
  },
  {
    toolType: TOOL_TYPES.BMI,
    title: '身体质量指数（BMI）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/bmi',
    routerPath: '/tools/formula/evaluation/bmi',
    miniPath: '/pages/tools/formula/evaluation/bmi',
    description: 'BMI计算与评估'
  },
]

export const FORMULA_TOOLS_EVALUATION = [
  {
    toolType: TOOL_TYPES.ZPS,
    title: 'ECOG体力状态评分(ZPS，5分法)',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/zpsStore',
    routerPath: '/tools/formula/evaluation/zpsStore',
    miniPath: '/pages/tools/formula/evaluation/zpsStore',
    description: 'ECOG体力状态评分'
  },
  {
    toolType: TOOL_TYPES.KPS,
    title: '体力状态评分（KPS，百分法）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/kpsStore',
    routerPath: '/tools/formula/evaluation/kpsStore',
    miniPath: '/pages/tools/formula/evaluation/kpsStore',
    description: 'Karnofsky体力状态评分'
  },
  {
    toolType: TOOL_TYPES.PAIN_GRADING,
    title: '癌种主诉疼痛分级法（VRS)',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/painGrading',
    routerPath: '/tools/formula/evaluation/painGrading',
    miniPath: '/pages/tools/formula/evaluation/painGrading',
    description: '癌种主诉疼痛分级法（VRS)'
  },
  {
    toolType: TOOL_TYPES.CTCAE,
    title: '常见不良事件评价标准（CTCAE）5.0',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/ctcae',
    routerPath: '/tools/formula/evaluation/ctcae',
    miniPath: '/pages/tools/formula/evaluation/ctcae',
    description: '常见不良事件评价标准'
  },  
  {
    toolType: TOOL_TYPES.STEPP,
    title: '早期绝经前激素受体阳性乳腺癌综合复发风险评分（STEPP评分）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/stepp',
    routerPath: '/tools/formula/evaluation/stepp',
    miniPath: '/pages/tools/formula/evaluation/stepp',
    description: '早期绝经前激素受体阳性乳腺癌综合复发风险评分（STEPP评分）'
  },
  {
    toolType: TOOL_TYPES.PAINWHO,
    title: '疼痛分级-WHO疼痛分级标准',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/painWho',
    routerPath: '/tools/formula/evaluation/painWho',
    miniPath: '/pages/tools/formula/evaluation/painWho',
    description: '疼痛分级-WHO疼痛分级标准'
  },
  {
    toolType: TOOL_TYPES.PAINNRS,
    title: '疼痛分级-数字分级评分法（NRS）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/painNrs',
    routerPath: '/tools/formula/evaluation/painNrs',
    miniPath: '/pages/tools/formula/evaluation/painNrs',
    description: '疼痛分级-数字分级评分法（NRS）'
  },
  {
    toolType: TOOL_TYPES.PAINVAS,
    title: '视觉模拟评分法 (VAS)',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/painVas',
    routerPath: '/tools/formula/evaluation/painVas',
    miniPath: '/pages/tools/formula/evaluation/painVas',
    description: '视觉模拟评分法 (VAS)'
  },
  {
    toolType: TOOL_TYPES.PAINFPS,
    title: '面部表情评分量表 (FPS)',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/painFps',
    routerPath: '/tools/formula/evaluation/painFps',
    miniPath: '/pages/tools/formula/evaluation/painFps',
    description: '面部表情评分量表 (FPS)'
  },
  {
    toolType: TOOL_TYPES.MIRELS,
    title: '病理性骨折风险评分系统（Mirels 评分系统）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/mirels',
    routerPath: '/tools/formula/evaluation/mirels',
    miniPath: '/pages/tools/formula/evaluation/mirels',
    description: '病理性骨折风险评分系统（Mirels 评分系统）'
  },
  {
    toolType: TOOL_TYPES.GCRSS,
    title: '中国人群胃癌风险评分系统（GC-RSS评分）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/gcRss',
    routerPath: '/tools/formula/evaluation/gcRss',
    miniPath: '/pages/tools/formula/evaluation/gcRss',
    description: '中国人群胃癌风险评分系统（GC-RSS评分）'
  },
  {
    toolType: TOOL_TYPES.CRS,
    title: '结直肠癌肝转移预后风险评分（CRS评分）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/crs',
    routerPath: '/tools/formula/evaluation/crs',
    miniPath: '/pages/tools/formula/evaluation/crs',
    description: '结直肠癌肝转移预后风险评分（CRS评分）'
  },
  {
    toolType: TOOL_TYPES.NORDLINGER,
    title: '结直肠癌肝转移预后风险评分（Nordlinger评分）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/nordlinger',
    routerPath: '/tools/formula/evaluation/nordlinger',
    miniPath: '/pages/tools/formula/evaluation/nordlinger',
    description: '结直肠癌肝转移预后风险评分（Nordlinger评分）'
  },
  {
    toolType: TOOL_TYPES.NSNRS,
    title: '营养风险筛查2002（NRS 2002 ）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/nsNrs',
    routerPath: '/tools/formula/evaluation/nsNrs',
    miniPath: '/pages/tools/formula/evaluation/nsNrs',
    description: '营养风险筛查2002（NRS 2002 ）'
  },
  {
    toolType: TOOL_TYPES.NSMUST,
    title: '营养不良通用筛查工具（MUST）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/nsMust',
    routerPath: '/tools/formula/evaluation/nsMust',
    miniPath: '/pages/tools/formula/evaluation/nsMust',
    description: '营养不良通用筛查工具（MUST）'
  },
  {
    toolType: TOOL_TYPES.PRABRADEN,
    title: '压疮危险评估量-Braden量表',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/praBraden',
    routerPath: '/tools/formula/evaluation/praBraden',
    miniPath: '/pages/tools/formula/evaluation/praBraden',
    description: '压疮危险评估量-Braden量表'
  },
  {
    toolType: TOOL_TYPES.PRANORTON,
    title: '压疮危险评估量-Norton量表',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/praNorton',
    routerPath: '/tools/formula/evaluation/praNorton',
    miniPath: '/pages/tools/formula/evaluation/praNorton',
    description: '压疮危险评估量-Norton量表'
  },
  {
    toolType: TOOL_TYPES.RECIST,
    title: '实体瘤的疗效评价标准（RECIST 1.1)',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/recist',
    routerPath: '/tools/formula/evaluation/recist',
    miniPath: '/pages/tools/formula/evaluation/recist',
    description: '实体瘤的疗效评价标准（RECIST 1.1)'
  },
  {
    toolType: TOOL_TYPES.CTS5,
    title: '临床治疗5年后风险评分（CTS5）',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/cts5',
    routerPath: '/tools/formula/evaluation/cts5',
    miniPath: '/pages/tools/formula/evaluation/cts5',
    description: '临床治疗5年后风险评分（CTS5）'
  },
  {
    toolType: TOOL_TYPES.CTCAE6,
    title: '常见不良事件评价标准（CTCAE）6.0',
    smallIcon: '//rs-os-lyh-dt-publicread-picture-bosmetadata-test.liangyihui.net/boss-upload/4slmNP5grtHHllqTK2sSRw/hQrTk4eHAF7U12IT.png',
    link: Global_root_path + '#/tools/formula/evaluation/ctcae6',
    routerPath: '/tools/formula/evaluation/ctcae6',
    miniPath: '/pages/tools/formula/evaluation/ctcae6',
    description: '常见不良事件评价标准（CTCAE）6.0'
  }
]

// 合并所有医学公式工具
export const FORMULA_TOOLS = [
  ...FORMULA_TOOLS_TREATMENT,
  ...FORMULA_TOOLS_EVALUATION
]

// 所有工具配置
export const ALL_TOOLS = [
  ...TOP_TOOLS,
  ...FUNCTION_TOOLS,
  ...FORMULA_TOOLS
]

// 根据工具类型获取工具配置（支持新旧配置）
export function getToolByType(toolType) {
  // 先从旧配置中查找
  let tool = ALL_TOOLS.find(tool => tool.toolType === toolType)
  // 如果旧配置中找不到，再从新配置中查找
  if (!tool) {
    tool = NEW_FORMULA_TOOLS.find(tool => tool.toolType === toolType)
  }
  return tool
}

// 根据工具类型获取工具标题
export function getToolTitle(toolType) {
  const tool = getToolByType(toolType)
  return tool ? tool.title : ''
}

// 根据工具类型获取工具埋点标题
export function getToolTrackTitle(toolType) {
  if (toolType > 6) {
    if (isTreatmentFormulaTool(toolType)) {
      return '计算公式'
    } else if (isEvaluationFormulaTool(toolType)) {
      return '医学量表'
    }
  } else {
    const tool = getToolByType(toolType)
    return tool ? tool.title : ''
  }
}

// 获取工具标题缩写
export function getToolMiniTitle(toolType) {
  const tool = getToolByType(toolType)
  return tool ? tool.miniTitle : ''
}
// 根据工具类型获取工具链接
export function getToolLink(toolType) {
  const tool = getToolByType(toolType)
  return tool ? tool.link : ''
}

// 根据工具类型获取工具路径（getToolPath 是 getToolLink 的别名）
export function getToolPath(toolType) {
  return getToolLink(toolType)
}

// 根据工具类型获取工具路由路径
export function getToolRouterPath(toolType) {
  const tool = getToolByType(toolType)
  return tool ? tool.routerPath : ''
}

// 根据工具类型获取小程序路径
export function getToolMiniPath(toolType) {
  if (toolType > 33) {
    // 临时处理新增公式 没有对应的小程序原生页面
    let miniPath = `/${doctorMiniProgramPaths.commonWeb}${encodeURIComponent(getToolLink(toolType))}`
    return miniPath
  }
  const tool = getToolByType(toolType)
  return tool ? tool.miniPath : ''
}

// 根据工具类型获取工具图标
export function getToolIcon(toolType) {
  const tool = getToolByType(toolType)
  return tool ? tool.img : ''
}

// 根据工具类型获取工具小图标（列表展示）
export function getToolSmallIcon(toolType) {
  switch (toolType) {
    case TOOL_TYPES.TNM:
      return SMALL_ICON_TNM
    case TOOL_TYPES.CLINICAL_GUIDE:
      return SMALL_ICON_GUIDE
    case TOOL_TYPES.MEDICATION:
      return SMALL_ICON_DRUG
    case TOOL_TYPES.CHEMOTHERAPY:
      return SMALL_ICON_CHEMO
  }
  // 公式类（treatment）：计算公式
  if (isTreatmentFormulaTool(toolType)) {
    return SMALL_ICON_FORMULA
  }
  // 量表类（evaluation）：医学量表
  if (isEvaluationFormulaTool(toolType)) {
    return SMALL_ICON_SCALE
  }
  const tool = getToolByType(toolType)
  return tool ? tool.smallIcon : ''
}

// 根据工具类型获取工具描述
export function getToolDescription(toolType) {
  const tool = getToolByType(toolType)
  return tool ? tool.description : ''
}

// 根据工具类型获取工具分类名称
export function getToolCategoryNameByType(toolType) {
  const tool = getToolByType(toolType)
  return tool ? tool.categoryName : ''
}

// 判断是否为公式工具
export function isFormulaTool(toolType) {
  return toolType > 6
}

// 判断是否为treatment类公式工具
export function isTreatmentFormulaTool(toolType) {
  // 检查旧配置中的treatment工具
  if (FORMULA_TOOLS_TREATMENT.some(tool => tool.toolType === toolType)) {
    return true
  }
  // 检查新配置中的treatment工具（新添加的都是treatment类型）
  if (NEW_FORMULA_TOOLS_TREATMENT && NEW_FORMULA_TOOLS_TREATMENT.some(tool => tool.toolType === toolType)) {
    return true
  }
  return false
}

// 判断是否为量表（evaluation）类公式工具
export function isEvaluationFormulaTool(toolType) {
  return FORMULA_TOOLS_EVALUATION.some(tool => tool.toolType === toolType)
}

// 获取公式工具列表
export function getFormulaTools() {
  return FORMULA_TOOLS
}

// 获取功能工具列表
export function getFunctionTools() {
  return FUNCTION_TOOLS
}

// 获取主要工具列表
export function getTopTools() {
  return TOP_TOOLS
}

// 工具分类
export const TOOL_CATEGORIES = {
  TOP: 'top',           // 主要工具
  FUNCTION: 'function', // 功能工具
  FORMULA: 'formula'    // 公式工具
}

// 根据分类获取工具列表
export function getToolsByCategory(category) {
  switch (category) {
    case TOOL_CATEGORIES.TOP:
      return TOP_TOOLS
    case TOOL_CATEGORIES.FUNCTION:
      return FUNCTION_TOOLS
    case TOOL_CATEGORIES.FORMULA:
      return FORMULA_TOOLS
    default:
      return ALL_TOOLS
  }
}

// 工具使用记录相关配置
export const TOOL_RECORD_CONFIG = {
  MAX_RECORDS: 5,        // 最大记录数
  PLATFORM_TYPE: 1,      // 平台类型
  AI_CASE_PATH: '/aicase' // AI病历夹路径
}

// 埋点相关配置
export const TRACKING_CONFIG = {
  PAGE_NAME: '医学公式',
  CONTENT_TYPE: '医学工具-聚合页',
  FEEDBACK_TITLE: '医学公式'
}

export default {
  TOOL_TYPES,
  TOP_TOOLS,
  FUNCTION_TOOLS,
  FORMULA_TOOLS,
  ALL_TOOLS,
  getToolByType,
  getToolTitle,
  getToolMiniTitle,
  getToolLink,
  getToolPath,
  getToolMiniPath,
  getToolRouterPath,
  getToolCategoryNameByType,
  getToolIcon,
  getToolDescription,
  isFormulaTool,
  getFormulaTools,
  getFunctionTools,
  getTopTools,
  TOOL_CATEGORIES,
  getToolsByCategory,
  TOOL_RECORD_CONFIG,
  TRACKING_CONFIG
}
